// Browser boot of the Rust/WASM Munos compiler.
//
// The wasm is a bundled asset: Vite emits packages/munos/wasm/munos_compiler.wasm
// as a hashed asset and rewrites this `?url` import to its served URL. We fetch
// those bytes once at page boot and instantiate the isomorphic adapter
// (`instantiateWasmCompiler`), yielding a synchronous MunosCompiler the host
// hands to its tenants (client halves) and its LocalHub (singleplayer server
// halves). See docs/rust-compiler-migration.md.

import { instantiateWasmCompiler, type MunosCompiler } from "@multinostalgia/munos";
import wasmUrl from "@multinostalgia/munos/wasm/munos_compiler.wasm?url";

let cached: Promise<MunosCompiler> | null = null;

/**
 * Load + instantiate the WASM compiler once per page. Memoized: every tile
 * shares the one module instance.
 */
export function loadBrowserCompiler(): Promise<MunosCompiler> {
  if (!cached) {
    cached = fetch(wasmUrl)
      .then((r) => {
        if (!r.ok) throw new Error(`fetching munos_compiler.wasm: HTTP ${r.status}`);
        return r.arrayBuffer();
      })
      .then((bytes) => instantiateWasmCompiler(bytes));
  }
  return cached;
}
